import { useEffect } from 'react'
import { track } from 'lib/amplitude'
import { Flex, Box } from 'ui'
import { LoginForm } from './LoginForm'
import { Photography } from '../Photography'
import { useSearchParams } from 'react-router-dom'
import { OktaLoginForm } from './OktaLoginForm'

export function LoginPage() {
  const [searchParams] = useSearchParams()
  const useOkta = searchParams.get('okta')

  useEffect(() => {
    track('impression, login')
  }, [])

  return (
    <Flex height={'100vh'} flexDirection={'row'}>
      <Box
        position={'relative'}
        width={[0, 0, 0, 0, 750]}
        display={['none', 'none', 'none', 'none', 'block']}
      >
        <Photography />
      </Box>
      <Box
        display={'grid'}
        flex={1}
        minHeight={'100vh'}
        p={[3, 3, 3, 3, 4]}
        overflow={'auto'}
      >
        {useOkta ? <OktaLoginForm /> : <LoginForm />}
      </Box>
    </Flex>
  )
}
